import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useComponentStyle = makeStyles({
	contentText: {
		...shorthands.margin("10px", 0, "10px", "13px"),
		textAlign: "start",
		">p": {
			...shorthands.margin(0),
			textWrap: "wrap",
		},
	},
	contentToolTip: {
		...shorthands.margin("10px", "13px", "10px", "13px"),
		textAlign: "start",
		">p": {
			...shorthands.margin(0),
			textWrap: "wrap",
		},
	},
	contentTextColor: {
		color: tokens.colorNeutralForeground1,
	},
	messageBarGroup: {
		position: "relative",
		marginLeft: "16px",
		marginRight: "16px",
		marginTop: "10px",
	},
	messageBar: {
		paddingLeft: "15px",
		alignItems: "flex-start",
		// Scroll lives on messageBarBody so this bar's border stays a fixed frame. The vertical breathing
		// room lives here, outside that scroll box, so it frames the text without counting toward the
		// 10-line cap and stays put while scrolling.
		paddingTop: "10px",
		paddingBottom: "10px",
	},
	messageBarBody: {
		width: "100%",
		minWidth: 0,
		// Cap the active-interaction text at 10 lines before it scrolls. lineHeight is pinned to the Fluent
		// token (its already-inherited value, so no visual change) so the cap is deterministic and doesn't
		// depend on the injected HTML's line-height. maxHeight is exactly 10 lines: spacing is messageBar's
		// padding and activeVariableText zeroes the wrapper's margins, so 10 full lines fit with no spurious
		// scrollbar and an 11th can't peek in. Not the `lh` unit — Chromium only added it in 133, and an
		// unsupported runtime drops the whole declaration, removing the cap. Calls override via messageBarTall.
		lineHeight: tokens.lineHeightBase300,
		maxHeight: `calc(10 * ${tokens.lineHeightBase300})`,
		overflowY: "auto",
	},
	activeVariableText: {
		// Spacing is owned by messageBar's padding; drop this wrapper's top/bottom margin so it doesn't add
		// to messageBarBody's scroll height (which would clip line 10 or trip a spurious scrollbar).
		marginTop: 0,
		marginBottom: 0,
	},
	// Calls have no conversation/compose area below the variable-text bar (unlike messaging, whose chat is
	// flex-sized to sit under it), so the active-interaction text may grow to 30vh — but never shorter than
	// messaging's 10-line cap (same basis as messageBarBody, so the guarantee holds by construction).
	// Merged onto messageBarBody for call interactions.
	messageBarTall: {
		maxHeight: `max(calc(10 * ${tokens.lineHeightBase300}), 30vh)`,
	},
	dismissButton: {
		position: "absolute",
		top: "8px",
		right: "8px",
		zIndex: 1,
		minWidth: "auto",
	},
	contentTrigger: {
		width: "100%",
	},
	aiIndicatorOffset: {
		marginLeft: "13px",
		marginBottom: "6px",
	},
});
